import { detectBrowser as e } from "../detectBrowser.mjs";
import t from "react";
import { ErrorReporterRegistry as n } from "@maat/store-error";
//#region src/react/ErrorBoundary.tsx
var r = class extends t.Component {
	constructor(...e) {
		super(...e), this.state = { error: null };
	}
	static getDerivedStateFromError(e) {
		return { error: e };
	}
	componentDidCatch(t, r) {
		let { context: i, location: a, platform: o, user: s, fingerprint: c } = this.props, l = o.platform === "web" && !o.browser ? {
			platform: "web",
			browser: e()
		} : o, u = {
			context: i,
			location: {
				...a,
				componentStack: r.componentStack ?? void 0
			},
			platform: l,
			user: s,
			fingerprint: c
		}, d = n.tryGet();
		d ? d.report(t, u) : typeof console < "u" && console.warn("[store-error] ErrorBoundary caught an error but no reporter is registered — call initSentry() at the app entry point.", t), this.setState({ componentStack: r.componentStack ?? void 0 });
	}
	render() {
		let { error: e } = this.state;
		if (e) {
			let { fallback: t } = this.props;
			return typeof t == "function" ? t(e, { componentStack: this.state.componentStack }) : t;
		}
		return this.props.children;
	}
};
//#endregion
export { r as ErrorBoundary };
